// <sale-countdown> — ticks down to a sale's start, then to its end, then hides.
//
// The section renders the digits server-side, but Shopify caches storefront HTML,
// so they are only a placeholder: the element recomputes against the shopper's
// clock on connect and every second after. Both moments carry a UTC offset
// (data-start / data-end are ISO 8601), so the count is the same in every zone.
//
// Phase changes swap the visually hidden status line so screen readers hear
// "starts in" or "ends in"; the digits themselves are not announced every second.
if (!customElements.get('sale-countdown')) {
  const UNITS = [
    ['days', 86400000],
    ['hours', 3600000],
    ['minutes', 60000],
    ['seconds', 1000],
  ];

  customElements.define(
    'sale-countdown',
    class SaleCountdown extends HTMLElement {
      connectedCallback() {
        this.start = Date.parse(this.dataset.start);
        this.end = Date.parse(this.dataset.end);
        if (Number.isNaN(this.end)) return;

        this.digits = Object.fromEntries(
          UNITS.map(([unit]) => [unit, this.querySelector(`[data-unit="${unit}"]`)])
        );
        this.status = this.querySelector('[data-status]');

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const now = Date.now();
        if (now >= this.end) {
          clearInterval(this.timer);
          this.closest('.shopify-section')?.setAttribute('hidden', '');
          return;
        }

        const upcoming = !Number.isNaN(this.start) && now < this.start;
        const phase = upcoming ? 'upcoming' : 'live';
        if (this.dataset.phase !== phase) {
          this.dataset.phase = phase;
          if (this.status) this.status.textContent = upcoming ? this.dataset.upcomingText : this.dataset.liveText;
        }

        let remaining = (upcoming ? this.start : this.end) - now;
        UNITS.forEach(([unit, ms]) => {
          const value = String(Math.floor(remaining / ms)).padStart(2, '0');
          remaining %= ms;
          const el = this.digits[unit];
          if (el && el.textContent !== value) el.textContent = value;
        });
      }
    }
  );
}
